<template>
    <span>
        <span :class="`sprite sprite-${theKey}`"></span>
        <span>{{(displayName ? getInfoLink(theKey).name : '')}}</span>
    </span>
</template>

<script>
    export default {
        props: {
            theKey: {
                type: String,
                required: true,
            },
            displayName: {
                type: Boolean,
                default: true
            }
        },
        data: function () {
            return {};
        },
        methods: {
            getInfoLink: function (key) {
                return this.$dataService.getLinkInfo(key);
            }
        }
    }
</script>

<style>

</style>
